import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=54ff6714&"
import script from "./BusinessInfo.vue?vue&type=script&lang=js&"
export * from "./BusinessInfo.vue?vue&type=script&lang=js&"
import style0 from "./BusinessInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VThemeProvider})
